import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import Select from 'react-select'

const normalizeValue = (value) => value == null ? '' : value.toString()

const SearchableSelect = ({
  options = [],
  value = '',
  onChange,
  placeholder = 'Type to search',
  isDisabled = false,
  isClearable = true,
  className = 'react-select success',
  classNamePrefix = 'react-select'
}) => {
  const selectRef = useRef(null)
  const [ inputValue, setInputValue ] = useState('')
  const selectedOption = (options || []).find((option) => normalizeValue(option.value) === normalizeValue(value)) || null

  const handleInputChange = (nextValue, actionMeta = {}) => {
    if (actionMeta.action === 'input-change') {
      setInputValue(nextValue)
    } else if ([ 'menu-close', 'set-value', 'input-blur' ].includes(actionMeta.action)) {
      setInputValue('')
    }

    return nextValue
  }

  const handleMenuOpen = () => {
    if (typeof window === 'undefined') return

    window.requestAnimationFrame(() => selectRef.current?.focus())
  }

  return (
    <Select
      ref={ selectRef }
      className={ className }
      classNamePrefix={ classNamePrefix }
      isClearable={ isClearable }
      isSearchable
      isDisabled={ isDisabled }
      openMenuOnFocus
      inputValue={ inputValue }
      options={ options }
      value={ selectedOption }
      onInputChange={ handleInputChange }
      onMenuOpen={ handleMenuOpen }
      onChange={ (option) => {
        setInputValue('')
        onChange(option?.value || '')
      } }
      placeholder={ placeholder }
      noOptionsMessage={ ({ inputValue: searchInput }) => searchInput ? 'No options found.' : 'Type to search.' }
    />
  )
}

SearchableSelect.propTypes = {
  options         : PropTypes.arrayOf(PropTypes.shape({
    value : PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    label : PropTypes.node
  })),
  value           : PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  onChange        : PropTypes.func.isRequired,
  placeholder     : PropTypes.string,
  isDisabled      : PropTypes.bool,
  isClearable     : PropTypes.bool,
  className       : PropTypes.string,
  classNamePrefix : PropTypes.string
}

export default SearchableSelect
